import React from 'react';
import { css } from '@emotion/react';

import { breakpoints } from '~/src/styles/styled-mixins';

import { AnnualPlan } from './AnnualPlan';
import { MonthlyPlan } from './MonthlyPlan';

const styles = {
  container: css({
    display: 'grid',
    gridTemplateAreas: `'annualPlan' 'monthlyPlan' '.'`,
    gridTemplateRows: `auto auto var(--Section-Padding)`,
    [breakpoints.minTablet]: {
      gridTemplateAreas: `'annualPlan' 'monthlyPlan'`,
      gridTemplateRows: `auto auto`,
    },
  }),
  background: css({
    zIndex: 1,
    borderRadius: 'var(--Border-Radius)',
    background: 'var(--Primary-Background, rgba(255, 243, 226, 0.50))',
    gridColumnStart: '1',
    gridRowStart: '1',
    gridRowEnd: '-1',
    [breakpoints.minTablet]: {
      gridColumnStart: '1',
      gridRowStart: '1',
      gridRowEnd: '2',
    },
  }),
  annualPlan: css({
    zIndex: 10,
    gridArea: 'annualPlan',
  }),
  monthlyPlan: css({
    zIndex: 10,
    gridArea: 'monthlyPlan',
  }),
};

export const MembershipPlans: React.FC = () => {
  return (
    <div css={styles.container}>
      <div css={styles.background} />
      <AnnualPlan css={styles.annualPlan} />
      <MonthlyPlan css={styles.monthlyPlan} />
    </div>
  );
};
